var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"campaign-child"},[(_vm.questionnaire && _vm.questionnaire.length > 0)?_c('questionnaire',{attrs:{"id":_vm.questionnaire[0]}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }